var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"view-header view-primary-navigation",class:{
		'state-active': _vm.$store.state.menuOpen,
		'state-has-scrolled': _vm.hasScrolledEnough,
	}},[_c('div',{staticClass:"view-branding"},[_c('ViewButtonHome',{on:{"click":_vm.Handle_OnClickHome}})],1),_c('nav',{staticClass:"view-primary-menu"},[_c('ViewButtonMenu',{on:{"click":_vm.Handle_OnClickMenu}})],1),_c('ViewNavigationMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }